module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "food-settings"
    }
  }, [_c('mu-card-header', {
    attrs: {
      "titleClass": "boldTitle largeTitle",
      "title": _vm.title,
      "subTitle": _vm.subTitle
    }
  }), _vm._v(" "), _c('mu-card-text', [_c('mu-row', {
    staticClass: "gutter",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    staticClass: "likes",
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "100"
    }
  }, [_c('mu-card', [_c('mu-paper', {
    attrs: {
      "id": "favorite-food-autocomplete"
    }
  }, [_c('mu-auto-complete', {
    staticClass: "inputInPaper",
    attrs: {
      "icon": "search",
      "underlineShow": false,
      "scroller": _vm.scroller,
      "inputClass": "favoriteAutocomplete",
      "openOnFocus": !_vm.favoriteSearching,
      "fullWidth": true,
      "hintText": _vm.$t('message.searchText'),
      "maxSearchResults": 10,
      "dataSource": _vm.favoriteDataSource,
      "dataSourceConfig": _vm.foodDataSourceConfig,
      "maxHeight": 250,
      "filter": "noFilter"
    },
    on: {
      "change": _vm.handleFavoriteSelected
    },
    model: {
      value: (_vm.favoriteSearchValue),
      callback: function($$v) {
        _vm.favoriteSearchValue = $$v
      },
      expression: "favoriteSearchValue"
    }
  })], 1), _vm._v(" "), _c('mu-list', [_c('mu-sub-header', [_vm._v("\n              " + _vm._s(_vm.$t('message.foodPreferencesLove')) + "\n            ")]), _vm._v(" "), (_vm.favorites.length === 0) ? _c('mu-sub-header', [_vm._v("\n              " + _vm._s(_vm.$t('message.emptyText')) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _vm._l((_vm.favorites), function(item, index) {
    return _c('mu-list-item', {
      key: 'fav-food-' + index,
      class: {
        odd: index % 2 === 0
      },
      attrs: {
        "title": item.food_name
      }
    }, [_c('mu-icon-button', {
      attrs: {
        "slot": "right",
        "icon": "delete"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.deleteFavorite(item)
        }
      },
      slot: "right"
    })], 1)
  })], 2)], 1)], 1), _vm._v(" "), _c('mu-col', {
    staticClass: "dislikes",
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "100"
    }
  }, [_c('mu-card', [_c('mu-paper', {
    attrs: {
      "id": "disliked-food-autocomplete"
    }
  }, [_c('mu-auto-complete', {
    staticClass: "inputInPaper",
    attrs: {
      "icon": "search",
      "underlineShow": false,
      "scroller": _vm.scroller,
      "inputClass": "dislikeAutocomplete",
      "openOnFocus": !_vm.favoriteSearching,
      "fullWidth": true,
      "hintText": _vm.$t('message.searchText'),
      "maxSearchResults": 10,
      "dataSource": _vm.dislikeDataSource,
      "dataSourceConfig": _vm.foodDataSourceConfig,
      "maxHeight": 250,
      "filter": "noFilter"
    },
    on: {
      "change": _vm.handleDislikeSelected
    },
    model: {
      value: (_vm.dislikeSearchValue),
      callback: function($$v) {
        _vm.dislikeSearchValue = $$v
      },
      expression: "dislikeSearchValue"
    }
  })], 1), _vm._v(" "), _c('mu-list', [_c('mu-sub-header', [_vm._v("\n              " + _vm._s(_vm.$t('message.foodPreferencesHate')) + "\n            ")]), _vm._v(" "), (_vm.dislikes.length === 0) ? _c('mu-sub-header', [_vm._v("\n              " + _vm._s(_vm.$t('message.emptyText')) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _vm._l((_vm.dislikes), function(item, index) {
    return _c('mu-list-item', {
      key: 'disliked-food-' + index,
      class: {
        odd: index % 2 === 0
      },
      attrs: {
        "title": item.food_name
      }
    }, [_c('mu-icon-button', {
      attrs: {
        "slot": "right",
        "icon": "delete"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.deleteDislike(item)
        }
      },
      slot: "right"
    })], 1)
  })], 2)], 1)], 1)], 1), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "large",
    attrs: {
      "disabled": _vm.isUpdating,
      "label": !_vm.isUpdating ? _vm.$t('message.updateText') : _vm.$t('message.updatingText'),
      "fullWidth": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b5d5eb9c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Settings/Food.vue
// module id = 3277
// module chunks = 1